import { Link } from 'react-router';
import { da } from '../i18n/da';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <main className={styles.page}>
      <p>{da.notFound}</p>
      <Link to="/" className={styles.link}>
        {da.play.backToStart}
      </Link>
    </main>
  );
}
